module.exports = __webpack_public_path__ + "media/video4.6fe62d50.mp4";